import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

export default function WeekText({ data }) {
  const [popupImages, setPopupImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.weekId) {
      const el = document.getElementById(`week-${location.state.weekId}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);

  // 👉 открытие галереи
  const openImage = (images, index) => {
    setPopupImages(images);
    setCurrentIndex(index);
  };

  const closePopup = () => {
    setPopupImages([]);
    setCurrentIndex(0);
  };

  const nextImage = useCallback(
    (e) => {
      e.stopPropagation();
      setCurrentIndex((prev) =>
        prev === popupImages.length - 1 ? 0 : prev + 1,
      );
    },
    [popupImages],
  );

  const prevImage = useCallback(
    (e) => {
      e.stopPropagation();
      setCurrentIndex((prev) =>
        prev === 0 ? popupImages.length - 1 : prev - 1,
      );
    },
    [popupImages],
  );

  // 👉 клавиатура (стрелки)
  useEffect(() => {
    const handleKey = (e) => {
      if (!popupImages.length) return;

      if (e.key === "ArrowRight") nextImage(e);
      if (e.key === "ArrowLeft") prevImage(e);
      if (e.key === "Escape") closePopup();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [popupImages, nextImage, prevImage]);

  return (
    <div className="week__table">
      {[...data].reverse().map((block) => (
        <div key={block.id} id={`week-${block.id}`} className="week__blank">
          <h4 className="week__title">
            <li className="week__content">{block.title}</li>
          </h4>

          <section>
            <div className="week__images">
              {block.images?.map((img, idx) => (
                <img
                  key={idx}
                  src={img.path}
                  alt={img.alt}
                  className="week__image"
                  onClick={() =>
                    openImage(
                      block.images.map((i) => i.path),
                      idx,
                    )
                  }
                />
              ))}
            </div>

            {block.files.map((file, index) => (
              <div key={index} className="licenses__blank-link">
                <h3 className="weektext__title">{file.label}</h3>
                <a
                  href={file.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="structure__download-link licenses__link"
                >
                  📄 Прочитать
                </a>
              </div>
            ))}
          </section>
        </div>
      ))}

      {popupImages.length > 0 && (
        <div className="popup" onClick={closePopup}>
          <button className="popup__prev" onClick={prevImage}>
            ←
          </button>

          <img
            src={popupImages[currentIndex]}
            alt="Просмотр"
            className="popup__image"
          />

          <button className="popup__next" onClick={nextImage}>
            →
          </button>
        </div>
      )}
    </div>
  );
}
